import TemplateExplorer from '../../../common/property-card/TemplateExplorer'
import type { TemplateProps } from '../../../common/property-card/card-parts'
import type { PropertyCardWidgetConfig } from '../config'
import type { ExploreWidgetConfig } from '../../explorer/config'

/**
 * Renders the explorer-look card for a single property, so a standalone card
 * can match the search-results grid exactly. Maps the property-card settings
 * onto the card slice of ExploreWidgetConfig; explorer-only knobs are pinned
 * to explorer's neutral defaults. The cast follows the related-properties
 * precedent: TemplateExplorer only reads `card`, `priceDisplay`,
 * `fullPriceAfterTax` and `showPetsFilter`, all present here.
 */
export default function TemplateExplorerAdapter({ property, options }: TemplateProps) {
  const pc = options as PropertyCardWidgetConfig
  const price = pc.showPrice ? ('lowest' as const) : ('none' as const)
  const explorerOptions = {
    card: {
      openInNewTab: pc.openInNewTab,
      showLocation: pc.showLocation,
      showType: pc.showPropertyType,
      showFeatures: pc.showFeatures,
      // The template system shows ratings whenever the property has them; keep
      // that behavior rather than explorer's off-by-default flag.
      showRating: true,
      showGroups: true,
      photosLimit: pc.maxImages,
      imageAspectRatio: pc.imageAspectRatio,
      slideAnimation: 'fade' as const,
    },
    // 'lowest' renders "From $X" straight from listing data — the standalone
    // card has no visitor dates, so the quote-driven modes never apply.
    // showNoDatesLabel pinned off: the explorer's "No dates available" swap
    // (#1064 Wave 4) is scoped to the explorer; this widget's own label
    // setting and opt-out are tracked in #1188.
    priceDisplay: { withDates: price, noDates: price, showNoDatesLabel: false },
    fullPriceAfterTax: false,
    showPetsFilter: false,
  } as unknown as ExploreWidgetConfig

  return <TemplateExplorer property={property} options={explorerOptions} />
}
